export default __webpack_public_path__ + "static/media/close-filter.c02e39f6.svg";